export default "__VITE_ASSET__CmbgaLwl__"